import { physicalSecurityEnumsSubCategoryEnum } from '@/gen/types/PhysicalSecurityEnumsSubCategory';

import { whenPathEquals } from './conditions';
import type { IncidentFieldRule } from './types';

export const physicalSecurityFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'What type of physical security incident is this?',
        description: 'Select the physical security issue observed.',
        order: 90,
    },
    {
        key: 'involvedParties',
        label: 'Who was involved?',
        description: 'State the role and name, e.g. employee - J. Smith, contractor - A. Jones.',
        kind: 'textarea',
        order: 100,
    },
    {
        key: 'immediateActionsTaken',
        label: 'What actions were taken immediately?',
        description: 'Describe any immediate steps taken to contain or respond to the incident.',
        kind: 'textarea',
        order: 110,
    },
    {
        key: 'physicalSecuritySystemAffected',
        label: 'Which security system was affected?',
        description: 'Select all affected systems, e.g. CCTV, access control, intrusion alarm.',
        order: 95,
        visibleWhen: whenPathEquals('subCategory', physicalSecurityEnumsSubCategoryEnum.PhysicalSecuritySystem),
    },
    {
        key: 'physicalAttack',
        label: 'Type of physical attack',
        description: 'Select the types of physical attacks that occurred.',
        order: 95,
        visibleWhen: whenPathEquals('subCategory', physicalSecurityEnumsSubCategoryEnum.PhysicalAttack),
    },
    {
        key: 'threatIncident',
        label: 'Type of threat',
        description: 'Select the types of threats, e.g. bomb threat, verbal threat, stalking.',
        order: 95,
        visibleWhen: whenPathEquals('subCategory', physicalSecurityEnumsSubCategoryEnum.SecurityThreat),
    },
    {
        key: 'physicalSecurityBreach',
        label: 'Type of security breach',
        description: 'Select the types of breaches, e.g. tailgating, forced entry, bypass.',
        order: 95,
        visibleWhen: whenPathEquals('subCategory', physicalSecurityEnumsSubCategoryEnum.PhysicalSecurityBreach),
    },
    {
        key: 'theftAndPropertyLoss',
        label: 'Type of theft or property loss',
        description: 'Select the types of theft or loss, e.g. equipment, personal property.',
        order: 95,
        visibleWhen: whenPathEquals('subCategory', physicalSecurityEnumsSubCategoryEnum.TheftAndPropertyLoss),
    },
    {
        key: 'workplaceViolenceAndAggressiveBehavior',
        label: 'Type of workplace violence or aggressive behaviour',
        description: 'Select the types of workplace violence or aggressive behaviour.',
        order: 95,
        visibleWhen: whenPathEquals(
            'subCategory',
            physicalSecurityEnumsSubCategoryEnum.WorkplaceViolenceAndAggressiveBehavior,
        ),
    },
    {
        key: 'politicalIncident',
        label: 'Type of political incident',
        description: 'Select the types of political incidents, e.g. protest, civil unrest.',
        order: 95,
        visibleWhen: whenPathEquals('subCategory', physicalSecurityEnumsSubCategoryEnum.Political),
    },
    {
        key: 'naturalDisaster',
        label: 'Type of natural disaster',
        description: 'Select the types of natural disasters, e.g. flood, earthquake, storm.',
        order: 95,
        visibleWhen: whenPathEquals('subCategory', physicalSecurityEnumsSubCategoryEnum.NaturalDisaster),
    },
    {
        key: 'vandalismAndPropertyDamage',
        label: 'Type of vandalism or property damage',
        description: 'Select the types of vandalism or damage observed.',
        order: 95,
        visibleWhen: whenPathEquals('subCategory', physicalSecurityEnumsSubCategoryEnum.VandalismAndPropertyDamage),
    },
    {
        key: 'unauthorizedAccess',
        label: 'Type of unauthorized access',
        description: 'Select the types of unauthorized access, e.g. forced, social engineering.',
        order: 95,
        visibleWhen: whenPathEquals('subCategory', physicalSecurityEnumsSubCategoryEnum.UnauthorizedAccess),
    },
];
